import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Menu } from 'semantic-ui-react';
import { withPopup } from '../../lib/popup';
import { Popup } from '../../lib/custom-ui';
import { useSteps } from '../../hooks';

import styles from './ActionsPopup.module.scss';
import ImportStep from '../ImportStep';

const StepTypes = {
  IMPORT: 'IMPORT',
};

const ActionsStep = React.memo(({ onImportUser, onClose }) => {
  const [t] = useTranslation();
  const [step, openStep, handleBack] = useSteps();

  const handleImportStepClick = useCallback(() => {
    openStep(StepTypes.IMPORT);
  }, [openStep]);

  if (step) {
    switch (step.type) {
      case StepTypes.IMPORT:
        return (
          <ImportStep
            title={t('action.importCustomers', {
              context: 'title',
            })}
            onImport={onImportUser}
            onBack={handleBack}
            onClose={onClose}
          />
        );
      default:
    }
  }

  return (
    <>
      <Popup.Header>{t('common.actions')}</Popup.Header>
      <Popup.Content>
        <Menu secondary vertical className={styles.menu}>
          <Menu.Item className={styles.menuItem} onClick={handleImportStepClick}>
            {t('action.editShipment', {
              context: 'title',
            })}
          </Menu.Item>
        </Menu>
      </Popup.Content>
    </>
  );
});

ActionsStep.propTypes = {
  onImportUser: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default withPopup(ActionsStep);
